import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SVGElement from './SVGElement';
import colors from '../../styling/colors';

export default class Hamburger extends Component {
  static propTypes = {
    className: PropTypes.string,
    height: PropTypes.string,
    strokeColor: PropTypes.string,
    width: PropTypes.string,
  };

  static defaultProps = {
    height: '1.5rem',
    strokeColor: colors('Lapel'),
    width: '1.5rem',
  };

  render() {
    const { className, height, strokeColor, width } = this.props;

    return (
      <SVGElement
        className={className}
        height={height}
        viewBox="0 0 24 24"
        width={width}
      >
        <path
          fill={strokeColor}
          d="M20.49,12H3.5a.5.5,0,0,1,0-1h17a.5.5,0,0,1,0,1Z"
        />
        <path
          fill={strokeColor}
          d="M20.49,5H3.5a.5.5,0,0,1,0-1h17a.5.5,0,0,1,0,1Z"
        />
        <path
          fill={strokeColor}
          d="M20.49,19H3.5a.5.5,0,0,1,0-1h17a.5.5,0,1,1,0,1Z"
        />
      </SVGElement>
    );
  }
}
